import { createAction, props } from '@ngrx/store';
import { GroupsCatalog } from './group-catalogs.models';
import { CatalogRequest } from '@core/services/common/catalog-operation';

export const loadGroupsCatalog = createAction('[GroupsCatalog] Load', props<CatalogRequest>());
export const loadGroupsCatalogSuccess = createAction(
  '[GroupsCatalog] Load Success',
  props<CatalogRequest & { groups: GroupsCatalog[] }>(),
);
export const loadGroupsCatalogFailure = createAction(
  '[GroupsCatalog] Load Failure',
  props<CatalogRequest & { error: string }>(),
);
export const resetGroupsCatalog = createAction('[GroupsCatalog] Reset');
export const refreshGroupsCatalog = createAction('[GroupsCatalog] Refresh');
